import LeagueSetupWizard from "./LeagueSetupWizard";

function LeagueSetupPage() {
  return (
    <div>
      <h2 className="mb-4 text-center">Let's Set Up Your League</h2>
      <LeagueSetupWizard />
    </div>
  );
}

export default LeagueSetupPage;
